<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="1000px" :close-on-click-modal="false"
        customClass="customWidth"
        @close="closeDialog">
        <div class="dialogContent" v-loading="loading">
            <div class="titleTop">
              活动基础信息
            </div>
            <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px">
              <!-- 活动模板 -->
              <div class="templateBox">
                <div class="templateBox_check">
                  <el-form-item label="模板名称" prop="templateUuid" ref="templateUuid" class="templateBox_checkName">
                      <el-radio-group v-model="form.templateUuid">
                        <el-radio :label="items.uuid" v-for="(items,index) in resource" :key="index" @change="getTemplateStyleInfo(items.name)">
                            {{items.name}}
                        </el-radio>
                      </el-radio-group>
                  </el-form-item>
                  <el-form-item prop="styleUuid" v-show="form.templateUuid" ref="styleUuid" class="templateBox_check2">
                    <div class="templateBox_check2Uuid">
                      <p>皮肤:</p>
                       <el-radio-group v-model="form.styleUuid">
                        <el-radio
                          @change="resourceImg(items.name)"
                          :label="items.uuid"
                          v-for="items in resource2"
                          :key="items.uuid">
                          {{items.name}}
                        </el-radio>
                      </el-radio-group>
                    </div>
                  </el-form-item>
                </div>
                <div class="templateBox_imgs" v-show="form.styleUuid">
                  <el-image
                    style="width: 103px; height: 100px"
                    :src="resourImgs"
                    :preview-src-list="resourImgsList"
                    ref="previewImg">
                  </el-image>
                  <p @click="previewImg">效果预览</p>
                </div>
              </div>
              <el-form-item label="活动名称" prop="activityName" ref="activityName">
                  <el-input v-model="form.activityName" maxlength="20" show-word-limit placeholder="请输入活动名称"></el-input>
              </el-form-item>
            <el-form-item label="领导审核" prop="audit" ref="audit">
                <el-switch
                    v-model="form.audit">
                </el-switch>
            </el-form-item>
              <!-- 活动封面和banner -->
              <div class="activeBanner">
                <el-form-item label="活动封面" prop="activityLogo" ref="activityLogo">
                    <div style="display: flex;"  v-loading="thumbnailLoading">
                        <el-upload
                            action="/service-center/upload/file/single"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" class="thumbnailClass">
                            <div class="avatar" v-if="!form.activityLogo">
                                <i class="el-icon-plus"></i>
                            </div>
                            <div>
                                <el-image
                                    v-if="form.activityLogo"
                                    :src="form.activityLogo"
                                    class="thumbnailClass"
                                    style="border: solid 1px #ececec;background-color: #f9f9f9;"
                                    :preview-src-list="thumbnailList">
                                </el-image>
                            </div>
                        </el-upload>
                    </div>
                    <p class="imgsMess">请上传591*300的图片,2M以内</p>
                </el-form-item>
                <el-form-item label="活动Banner" prop="bannerUrl" ref="bannerUrl">
                    <div style="display: flex;"  v-loading="thumbnailLoading6">
                        <el-upload
                            action="/service-center/upload/file/single"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleBannerSuccess"
                            :before-upload="beforeBannerUpload" class="thumbnailClass">
                            <div class="avatar" v-if="!form.bannerUrl">
                                <i class="el-icon-plus"></i>
                            </div>
                            <div>
                                <el-image
                                    v-if="form.bannerUrl"
                                    :src="form.bannerUrl"
                                    class="thumbnailClass"
                                    style="border: solid 1px #ececec;background-color: #f9f9f9;"
                                    :preview-src-list="thumbnailList">
                                </el-image>
                            </div>
                        </el-upload>
                    </div>
                    <p class="imgsMess">请上传1920*600的图片,2M以内</p>
                </el-form-item>
              </div>
                <div class="activeBanner">
                    <el-form-item label="app活动Banner" prop="appBannerUrl" ref="appBannerUrl">
                        <!-- 图片上传 -->
                        <div style="display: flex;"  v-loading="thumbnailLoading7">
                            <el-upload
                                action="/service-center/upload/file/single"
                                :show-file-list="false"
                                :headers="headers"
                                :on-success="handleSuccessImgUrl1" class="thumbnailClass">
                                <div class="avatar" v-if="!form.appBannerUrl">
                                    <i class="el-icon-plus"></i>
                                </div>
                                <div>
                                    <el-image
                                        v-if="form.appBannerUrl"
                                        :src="form.appBannerUrl"
                                        class="thumbnailClass"
                                        style="border: solid 1px #ececec;background-color: #f9f9f9;"
                                        :preview-src-list="thumbnailList">
                                    </el-image>
                                </div>
                            </el-upload>
                        </div>
                        <p class="imgsMess">建议上传375*207的图片,2M以内</p>
                    </el-form-item>
                </div>
              <el-form-item label="活动简介" prop="content" ref="content">
                  <el-input v-model="form.content" placeholder="请输入活动简介" type="textarea"></el-input>
              </el-form-item>
              <!-- 宣传图和宣传视频 -->
              <div class="activeBanner">
                <el-form-item label="宣传图" prop="activityUrl" ref="activityUrl">
                    <!-- 图片上传 -->
                    <div style="display: flex;"  v-loading="thumbnailLoading4">
                      <el-upload
                          action="/service-center/upload/file/single"
                          :show-file-list="false"
                          :headers="headers"
                          :on-success="handleSuccessImgUrl"
                          :before-upload="beforeUploadImgUrl" class="thumbnailClass20">
                          <div class="avatar2" v-if="!form.activityUrl">
                              <p><i class="el-icon-plus"></i>图片上传</p>
                          </div>
                          <div v-if="form.activityUrl" class="imageBox">
                              <el-image
                                  :src="form.activityUrl"
                                  class="thumbnailClass2"
                                  style="border: solid 1px #ececec;background-color: #f9f9f9;"
                                  :preview-src-list="thumbnailList">
                              </el-image>
                              <div class="hoverImages"></div>
                              <i class="imageBoxClear el-icon-close" @click.stop="getClearIamgs('img')"></i>
                          </div>
                      </el-upload>
                    </div>
                    <p class="imgsMess">请上传1100*600的图片,2M以内</p>
                </el-form-item>
                <el-form-item label="宣传视频" prop="activityVideoUrl" ref="activityVideoUrl">
                  <!-- 视频上传 -->
                  <div style="display: flex;"  v-loading="thumbnailLoading5">
                    <el-upload
                        action="/service-center/upload/file/single"
                        :show-file-list="false"
                        :headers="headers"
                        :on-success="handleSuccessVideoUrl"
                        :before-upload="beforeUploadVideoUrl" class="thumbnailClass20">
                        <div class="avatar2" v-if="!form.activityVideoUrl">
                            <p><i class="el-icon-plus"></i>视频上传</p>
                        </div>
                        <div class="avatar2 imageBox" v-else>
                            <video-player
                              class="video-player vjs-custom-skin"
                              ref="videoPlayer"
                              :playsinline="true"
                              :options="playerOptions"
                            ></video-player>
                            <div class="hoverImages"></div>
                            <i class="imageBoxClear el-icon-close" @click.stop="getClearIamgs('video')"></i>
                        </div>
                    </el-upload>
                  </div>
                  <p class="imgsMess">请上传50M以内视频</p>
                </el-form-item>
              </div>
                <div class="titleTop">
                    活动时间
                </div>
                <el-form-item label="活动时间" prop="nodeList" ref="nodeList">
                    <div style="position: relative;">
                        <div>
                            <el-form-item :prop="'nodeList'" :rules="rules.nodeList">
                                <el-table
                                    border
                                    :data="form.nodeList"
                                    style="width: 100%">
                                    <el-table-column
                                        prop="name"
                                        label="节点名称">
                                    </el-table-column>
                                    <el-table-column
                                        prop="startDate"
                                        label="开始时间">
                                    </el-table-column>
                                    <el-table-column
                                        prop="endDate"
                                        label="结束时间">
                                    </el-table-column>
                                    <el-table-column
                                        prop="status"
                                        label="节点状态">
                                        <template slot-scope="scope">
                                            {{ showStatusInfo(scope.row.status) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="address"
                                        label="操作">
                                        <template slot-scope="scope">
                                            <el-button  type="text" size="small" @click="updateActivityDateInfo(scope.row,scope.$index)">修改</el-button>
                                            <el-button  type="text" size="small" @click="delActivityDateNext(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                            <el-button  v-if="form.nodeList.length < 5" class="addNext" type="primary" size="small" @click="addActivityDateData">点击添加时间节点</el-button>
                        </div>
                    </div>
                </el-form-item>
                <div class="titleTop">
                    赛道规则
                </div>
                <el-form-item label="赛道信息" prop="wayList" ref="wayList">
                    <div style="position: relative;">
                        <div>
                            <el-form-item :prop="'wayList'" :rules="rules.wayList">
                                <el-table
                                    border
                                    :data="form.wayList"
                                    style="width: 100%">
                                    <el-table-column
                                        prop="name"
                                        label="赛道名称">
                                    </el-table-column>
                                    <el-table-column
                                        prop="voteRatio"
                                        label="投票占比">
                                    </el-table-column>
                                    <el-table-column
                                        prop="judgesAppraisalRatio"
                                        label="评委评分占比">
                                    </el-table-column>
                                    <el-table-column
                                        prop="address"
                                        label="操作">
                                        <template slot-scope="scope">
                                            <el-button  type="text" size="small" @click="updateTrackInfo(scope.row,scope.$index)">修改</el-button>
                                            <el-button  type="text" size="small" @click="delTrackNext(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                            <el-button class="addNext" type="primary" size="small" @click="addTrackData">点击添加赛道</el-button>
                        </div>
                    </div>
                </el-form-item>
            <div class="titleTop">
                投票规则
            </div>
            <el-form-item label="投票次数" prop="voteNum" ref="voteNum">
                <el-input v-model="form.voteNum" placeholder="请输入投票次数" style="width: 90%;"></el-input>
            </el-form-item>
            <el-form-item label="投票时间" prop="activityVoteDate" ref="activityVoteDate">
                <el-date-picker
                  v-model="form.activityVoteDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <div class="titleTop">
                活动详情
            </div>
            <el-form-item label="组织机构" prop="organizationList" ref="organizationList">
                <div style="position: relative;">
                    <div>
                        <div v-for="(item,index) in organizationList" :key="index" class="modelHeightRangeClass">
                            <el-form-item>
                                <el-input v-model="item.organizationName"
                                          placeholder="请输入组织机构名称"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input type="textarea" v-model="item.organizationContent" class="organiContent"
                                          placeholder="请输入组织机构内容"></el-input>
                            </el-form-item>
                            <span v-if="index !== 0" style="padding-left: 120px;cursor: pointer;color: #157efb;line-height: 40px;" @click="delOrganizationInfo(index)">删除</span>
                        </div>
                        <el-button class="addNext" type="primary" size="small" @click="addOrganizationInfo">点击添加下一条</el-button>
                    </div>
                </div>
            </el-form-item>
             <!-- <el-form-item label="主办方" prop="sponsorName" ref="sponsorName">
                  <el-input v-model="form.sponsorName" placeholder="请输入主办方"></el-input>
              </el-form-item>
              <el-form-item label="承办方" prop="undertakerName" ref="undertakerName">
                  <el-input v-model="form.undertakerName" placeholder="请输入承办方"></el-input>
              </el-form-item>
              <el-form-item label="协办方" prop="jointlyName" ref="jointlyName">
                  <el-input v-model="form.jointlyName" placeholder="请输入协办方"></el-input>
              </el-form-item>-->
              <el-form-item label="合作方" prop="logoList" ref="logoList">
                  <div style="display: flex;"  v-loading="thumbnailLoading2" class="thumbnailClass20_img thumbnailClassLogo">
                      <el-upload
                        action="/service-center/upload/file/single"
                        list-type="picture-card"
                        :headers="headers"
                        :file-list="form.logoList"
                        :on-success="handleAvatarSuccess2"
                        :before-upload="beforeAvatarUpload2">
                          <i slot="default" class="el-icon-plus"></i>
                          <div slot="file" slot-scope="{file}">
                            <img
                              class="el-upload-list__item-thumbnail"
                              :src="file.url" alt=""
                            >
                            <span class="el-upload-list__item-actions">
                              <span
                                v-if="!disabled"
                                class="el-upload-list__item-delete"
                                @click="handleRemove_logo(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                      </el-upload>
                  </div>
                  <p class="imgsMess">请上传 190 * 90 的图片</p>
              </el-form-item>
              <el-form-item label="参赛要求" prop="entryDemand"  ref="entryDemand">
                <editor id="editor" v-model='form.entryDemand' @input="editHomepageInput" :init='editorInit'></editor>
              </el-form-item>
              <el-form-item label="参赛规则" prop="entryRule" ref="entryRule">
                <editor  v-model='form.entryRule' @input="editHomepageInput2" :init='editorInit'></editor>
              </el-form-item>
              <el-form-item label="相关资料" prop="fileContent" ref="fileContent">
                  <el-input v-model="form.fileContent" placeholder="请输入文字说明" type="textarea"></el-input>
                  <el-upload
                    class="upload-demo"
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :on-success="handleSuccessUrl"
                    :before-upload="handleUploadBefore"
                    :on-remove="handleRemove"
                    :file-list="form.fileList">
                    <el-button size="small" icon="el-icon-upload2">上传附件</el-button>
                  </el-upload>
              </el-form-item>
              <el-form-item label="参赛指南" prop="entryGuide" ref="entryGuide">
                <editor  v-model='form.entryGuide' @input="editEntryGuideInput" :init='editorInit'></editor>
              </el-form-item>
              <el-form-item class="submitButtonClass">
                  <el-button  @click="previewWeb">预览</el-button>
                  <el-button type="primary" @click="submit(1)">发布</el-button>
                  <el-button  @click="submit(0)" v-if="type==='add'">保存</el-button>
                  <el-button  @click="submit(0)" v-if="type==='edit'">保存</el-button>
                  <el-button  @click="dialogVisible = false">取消</el-button>
              </el-form-item>
          </el-form>
        </div>
        <active-preview ref="activePreviewRefs"></active-preview>
        <active-preview2 ref="activePreviewRefs2"></active-preview2>
        <active-preview3 ref="activePreviewRefs3"></active-preview3>

        <track-detail-dialog ref="trackDetailRefs" @submit="getTrackDetail"></track-detail-dialog>
        <activity-date-dialog ref="activityDateRefs" @submit="getActivityDateInfo"></activity-date-dialog>
    </el-dialog>
</template>

<script>
import { saveActivityInfo, getActivityTemplateList, editActivityInfo,
    getActivityTemplateStyleList, getActivityDetail, uploadFile } from '../../../utils/interface';
import tinymce from '@/components/tinymce'
// 模板一
import activePreview from '../activePreview';
// 模板二
import activePreview2 from '../activePreview2';
// 模板三
import activePreview3 from '../activePreview3';
import trackDetailDialog from './trackDetailsDialog';
import activityDateDialog from './activityDateDialog';
/* 引入插件 */
import 'tinymce/plugins/image'
import 'tinymce/plugins/table'
export default {
    name: "materialManagementDialog",
    data() {
      return {
        resourImgs:'',
        resourImgsList: [],
        fileListUrl: [],
        dialogVisible: false,
        cascaderShow: false,
        loading: false,
        id: '',
        title: '',
        headers: {
            'Authorization': 'Bearer ' + window.sessionStorage.getItem("api_access_token")
        },
        dialogFormVisible:false,
        form: {
            templateUuid: '',
            styleUuid: '',
            styleName:'',
            activityName: '',
            audit:false,
            sponsorName: '',
            undertakerName: '',
            jointlyName: '',
            activityCollectTime: [],
            activityCollectStartTime:"",
            activityCollectEndTime:"",
            activityChooseTime: [],
            activityChooseStartTime:"",
            activityChooseEndTime:"",
            activityShowStartDate: "",
            activityVoteDate:[],
            activityVoteStartDate:"",
            activityVoteEndDate:"",
            logoList:[],
            activityLogo: '',
            appBannerUrl: '',
            voteRatio: '',
            judgesAppraisalRatio: '',
            voteTime: '',
            typeList: [],
            awardList: [],
            activityUrl: '',
            activityVideoUrl: '',
            content: '',
            entryDemand: '',
            entryRule: '',
            entryGuide: '',
            fileContent:"",
            fileList:[],
            status:"",
            bannerUrl:"",
            voteNum:0,
            wayList:[],
            nodeList:[],
            organizationList:[],
        },
        organizationList:[],
        dialogImageUrl: '',
        dialogVisibleImg: false,
        disabled: false,
        resource:[],
        resource2:[],
        rules: {
            templateUuid: [
                {required: true, message: '请选择模板名称', trigger: 'change'}
            ],
            styleUuid: [
                {required: true, message: '请选择模板皮肤', trigger: 'change'}
            ],
            activityName: [
                {required: true, message: '请输入活动名称', trigger: 'blur'}
            ],
            sponsorName: [
                {required: true, message: '请输入主办方', trigger: 'blur'}
            ],
           /* activityCollectTime: [
                {required: true, message: '请选择作品征集时间', trigger: 'change'}
            ],
            activityChooseTime: [
                {required: true, message: '请选择作品评选时间', trigger: 'change'}
            ],
            activityShowStartDate: [
                {required: true, message: '请选择作品公示时间', trigger: 'change'}
            ],*/
            activityLogo: [
                {required: true, message: '请上传活动封面图', trigger: 'blur'}
            ],
            appBannerUrl:[
                {required: true, message: '请上传app活动banner图片', trigger: 'blur'}
            ],
            bannerUrl: [
                {required: true, message: '请上传活动banner图', trigger: 'blur'}
            ],
            voteNum:[
                {required: true, message: '请输入投票次数', trigger: 'blur'}
            ],
            /*voteRatio:[
                {required: true, message: '请输入投票占比', trigger: 'blur'}
            ],
            judgesAppraisalRatio:[
                {required: true, message: '请输入评委评分占比', trigger: 'blur'}
            ],*/
            activityVoteDate:[
                {required: true, message: '请选择投票时间', trigger: 'blur'}
            ],
            content:[
                {required: true, message: '请输入活动简介', trigger: 'blur'}
            ],
            entryGuide:[
                {required: true, message: '请输入参赛指南', trigger: 'change'}
            ],
        },
        typeOptions: [],
        processTypeList: [],
        thumbnailLoading: false,
        thumbnailList: [],
        thumbnailLoading2: false,
        thumbnailLogoList: [],
        thumbnailLoading4: false,
        thumbnailLoading5: false,
        formSuccess: {
            awardName: '',
            awardNumber: '',
            awardContent: '',
            awardUrl: '',
            sort:1,
        },
        thumbnailListForm:[],
        thumbnailLoading3: false,
        thumbnailLoading6: false,
        thumbnailLoading7: false,
        rulesSuccess:{
            awardName:[
                {required: true, message: '请输入奖项名称', trigger: 'blur'}
            ],
            awardNumber:[
                {required: true, message: '请输入奖项人数', trigger: 'blur'}
            ],
            awardContent:[
                {required: true, message: '请输入奖品名称', trigger: 'blur'}
            ],
            /*awardUrl:[
                {required: true, message: '请上传奖项配图', trigger: 'blur'}
            ],*/
            sort:[
                {required: true, message: '请设置排序', trigger: 'blur'}
            ],
        },
        type:"",
        playerOptions : {
            // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
            autoplay: false, //如果true,浏览器准备好时开始回放。
            muted: true, // 默认情况下将会消除任何音频。
            loop: true, // 导致视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [{
                type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                src: "" //url地址
            }],
            poster: "", //你的封面地址
            // width: document.documentElement.clientWidth, //播放器宽度
            // notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
                timeDivider: false,
                durationDisplay: false,
                remainingTimeDisplay: false,
                fullscreenToggle: false  //全屏按钮
            },
        },
        updateIndex:'',
        // 合作方logo上传上传展示的数组
        // logolistShow: []
        editorInit: {//编辑框的配置项目
          selector: '#editor',
          /* 语言配置，将其转化为中文，如果main.js配置不起作用，也可在这里配置 */
          language_url: '/static/tinymce/langs/zh_CN.js',
          language: 'zh_CN',
          // images_upload_url: '/service-center/upload/file/single',
          /* 引入的插件，与上面相对应 */
          plugins: 'image table imagetools',
          images_upload_handler: (blobInfo, success, failure) => {
              var formData;
              formData = new FormData();
              formData.append('file',blobInfo.blob(), blobInfo.filename());

              // 上传接口
              uploadFile(formData).then((res)=>{
                success(res.url);
              })
          },
          /* 菜单栏配置 */
          // menubar: 'file edit insert view format table',//菜单栏显示的项目标题
          menubar: false,//隐藏菜单栏
          // menu: {//菜单栏项目点击后下拉的内容，items为下拉内容
          //   file: {title: 'File', items: 'newdocument'},
          //   edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
          //   insert: {title: 'Insert', items: 'link media | template hr'},
          //   view: {title: 'View', items: 'visualaid'},
          //   format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
          //   //items里的所有配置项所属为table插件，如果没引入table插件，菜单栏该项目不显示
          //   table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
          // },
          font_formats: 'Arial=arial,helvetica,sans-serif; 宋体=SimSun;  微软雅黑=Microsoft Yahei; Impact=impact,chicago;', //字体
          fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px 64px 72px', //文字大小

          /* 工具栏配置 */
          toolbar:'bold italic underline strikethrough  | fontselect | fontsizeselect | formatselect \
            | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist \
            | outdent indent blockquote | removeformat| undo redo | link unlink image media pageembed \
            insertdatetime table  hr pagebreak codesample | code fullscreen preview', //工具条
          /* 其它配置 */
          branding: false, //水印
          elementpath: false, //底部元素路径
          paste_data_images: true, //允许粘贴图片
          height: 300,//编辑框高度
          statusbar: false, // 隐藏编辑器底部的状态栏
          toolbar_mode: 'wrap'
        },
        templateClass:''
      }
    },
    components: {
        tinymce,
        activePreview,
        activePreview2,
        activePreview3,
        trackDetailDialog,
        activityDateDialog,
    },
    mounted(){
    },

    methods: {
        // 删除组织机构
        delOrganizationInfo(index){
            this.organizationList.splice(index,1);
        },
        // 新增组织机构
        addOrganizationInfo(){
            this.organizationList.push({
                organizationName: '',
                organizationContent: '',
            });
        },
       handleRemove_logo(file) {
        this.form.logoList.forEach((item,index)=>{
          if(item.uid == file.uid) {
            this.form.logoList.splice(index ,1)
          }
        })
      },
      init(type,uuid) {
            this.organizationList = [];
          this.type = type;
          this.reset();
          // 查询信息
          getActivityTemplateList().then((res)=>{
              if(res.success){
                this.resource = res.data;
                console.log('this.resource',this.resource );
              }
          });
          if (type === 'add') {
              this.title = '创建活动';
          } else {
              this.title = '编辑';
              // 查询详情
              getActivityDetail(uuid).then((res)=>{
                  this.form = {
                      uuid:res.uuid,
                      templateUuid: res.templateUuid,
                      styleUuid: res.styleUuid,
                      styleName: res.styleName,
                      activityName: res.activityName,
                      audit: res.audit,
                      sponsorName: res.sponsorName,
                      undertakerName: res.undertakerName,
                      jointlyName: res.jointlyName,
                      activityCollectTime: [],
                      activityCollectStartTime:res.activityCollectStartTime,
                      activityCollectEndTime:res.activityCollectEndTime,
                      activityChooseTime: [],
                      activityChooseStartTime:res.activityChooseStartTime,
                      activityChooseEndTime:res.activityChooseEndTime,
                      activityShowStartDate: res.activityShowStartDate,
                      activityVoteDate:[],
                      activityVoteStartDate:res.activityVoteStartDate,
                      activityVoteEndDate:res.activityVoteEndDate,
                      logoList:res.logoList,
                      activityLogo: res.activityLogo,
                      bannerUrl: res.bannerUrl,
                      voteRatio:res.voteRatio,
                      judgesAppraisalRatio: res.judgesAppraisalRatio,
                      voteTime: res.voteTime,
                      typeList: res.typeList,
                      awardList: res.awardList,
                      activityUrl: res.activityUrl,
                      activityVideoUrl: res.activityVideoUrl,
                      content: res.content,
                      entryDemand: res.entryDemand,
                      entryRule: res.entryRule,
                      editDate: res.editDate,
                      entryGuide: res.entryGuide,
                      fileContent:res.fileContent,
                      fileList:res.fileList,
                      status:res.status,
                      nodeList:res.nodeList,
                      voteNum:res.voteNum,
                      wayList:res.wayList,
                      appBannerUrl:res.appBannerUrl,
                  };
                  this.organizationList = res.organizationList;
                  this.templateClass = res.templateName
                  //this.form.awardList = this.compare(this.form.awardList,'sort');
                  this.resourceImg(res.styleName);
                  if(res.activityVideoUrl!=''){
                      this.playerOptions.sources[0].src = res.activityVideoUrl
                  }
                  // 合作方logo
                  this.thumbnailLogoList = this.form.logoList;
                  // 修改参数
                  //this.form.activityCollectTime.push(new Date(this.form.activityCollectStartTime));
                  //this.form.activityCollectTime.push(new Date(this.form.activityCollectEndTime));
                  //this.form.activityChooseTime.push(new Date(this.form.activityChooseStartTime));
                  //this.form.activityChooseTime.push(new Date(this.form.activityChooseEndTime));
                  //this.form.activityVoteDate.push(new Date(this.form.activityVoteStartDate));
                  if(this.form.activityVoteStartDate!=""){
                      this.form.activityVoteDate.push(new Date(this.form.activityVoteStartDate));
                  }
                  if(this.form.activityVoteEndDate!=""){
                      this.form.activityVoteDate.push(new Date(this.form.activityVoteEndDate));
                  }
                  /*this.form.activityShowStartDate = new Date(this.form.activityShowStartDate);*/
                  getActivityTemplateStyleList({templateUuid:this.form.templateUuid}).then((res)=>{
                      if(res.success){
                          this.resource2 = res.data;
                      }
                  });
              });
          }
          this.dialogVisible = true;
      },
      previewImg(){
        this.$refs.previewImg.showViewer = true
      },
      closeDialog(){
        this.$refs.ruleForm.resetFields();
      },
      getTemplateStyleInfo(name){
          getActivityTemplateStyleList({templateUuid:this.form.templateUuid}).then((res)=>{
              if(res.success){
                  this.resource2 = res.data;
                  this.templateClass = name
              }
          });
      },
      // logo上传
      handleAvatarSuccess2(res, file) {
          this.form.logoList.push({url:res.url});
          // this.thumbnailLogoList.push({url:res.url});
          this.thumbnailLoading2 = false;
          this.$refs.ruleForm.validateField('logoList');
      },
      beforeAvatarUpload2(file) {
          this.thumbnailLoading2 = true;
          const isJPG = file.type.indexOf('image') !== -1;
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isJPG) {
              this.thumbnailLoading2 = false;
              this.$message.warning('上传图片只能是图片格式!');
              this.thumbnailLoading2 = false
          }
          if (!isLt2M) {
              this.thumbnailLoading2 = false;
              this.$message.warning('上传图片大小不能超过 2MB!');
              this.thumbnailLoading2 = false
          }
          return isJPG && isLt2M;
      },
      // 缩略图上传
      handleAvatarSuccess(res, file) {
          this.form.activityLogo = res.url;
          this.thumbnailLoading = false;
          this.$refs.ruleForm.validateField('activityLogo');
      },
      beforeAvatarUpload(file) {
          this.thumbnailLoading = true;
          const isJPG = file.type.indexOf('image') !== -1;
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isJPG) {
              this.thumbnailLoading = false
              this.$message.warning('上传图片只能是图片格式!');
              this.thumbnailLoading = false
          }
          if (!isLt2M) {
              this.thumbnailLoading = false
              this.$message.warning('上传图片大小不能超过 2MB!');
              this.thumbnailLoading = false
          }
          return isJPG && isLt2M;
      },
      // banner图上传
      handleBannerSuccess(res, file) {
          this.form.bannerUrl = res.url;
          this.thumbnailLoading6 = false;
          this.$refs.ruleForm.validateField('bannerUrl');
      },
      beforeBannerUpload(file) {
          this.thumbnailLoading6 = true;
          const isJPG = file.type.indexOf('image') !== -1;
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isJPG) {
              this.thumbnailLoading6 = false
              this.$message.warning('上传图片只能是图片格式!');
              this.thumbnailLoading6 = false
          }
          if (!isLt2M) {
              this.thumbnailLoading6 = false
              this.$message.warning('上传图片大小不能超过 2MB!');
              this.thumbnailLoading6 = false
          }
          return isJPG && isLt2M;
      },
      // 相关资料附件
        handleUploadBefore(file){
            const isJPG = file.type.indexOf('image') !== -1;
            const isVideo = file.type.indexOf('video') !== -1;
            const isLt50M = file.size / 1024 / 1024 < 50;
            const isVideo100M = file.size / 1024 / 1024 < 100;
            if(isJPG){
                // 图片
                if (!isLt50M) {
                    this.$message.warning('图片大小不能超过 50MB!');
                }
                return isJPG && isLt50M;
            }else if(isVideo){
                // 视频
                if (!isVideo100M) {
                    this.$message.warning('视频大小不能超过 100MB!');
                }
                return isVideo && isVideo100M;
            }
            // 其他不显示大小
        },
      handleSuccessUrl(res, file) {
          this.form.fileList.push({name:res.name,url:res.url});
          this.$refs.ruleForm.validateField('fileContent')
      },
      handleRemove(file, fileList) {
          this.form.fileList = fileList;
          this.$refs.ruleForm.validateField('fileContent')
      },
        // appbanner图
        // 大赛简介图片上船
        handleSuccessImgUrl1(res, file) {
            this.form.appBannerUrl = res.url;
            this.thumbnailLoading7 = false;
            this.$refs.ruleForm.validateField('appBannerUrl')
        },
        beforeUploadImgUrl1(file) {
            this.thumbnailLoading7 = true;
            const isJPG = file.type.indexOf('image') !== -1;
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.thumbnailLoading7 = false;
                this.$message.warning('上传图片只能是图片格式!');
                this.thumbnailLoading7 = false;
            }
            if (!isLt2M) {
                this.thumbnailLoading7 = false;
                this.$message.warning('上传图片大小不能超过 2MB!');
                this.thumbnailLoading7 = false;
            }
            let _this = this;
            let imgWidth = "";
            let imgHeight = "";
            let width = 375;
            let height = 207;
            // let isSize = new Promise(function (resolve, reject) {
            //     let _URL = window.URL || window.webkitURL;
            //     let img = new Image();
            //     img.onload = function () {
            //         imgWidth = img.width;
            //         imgHeight = img.height;
            //         let valid = img.width == width && img.height == height;
            //         valid ? resolve() : reject();
            //     };
            //     img.src = _URL.createObjectURL(file);
            // }).then(() => {
            //     return file;
            // }, () => {
            //     this.thumbnailLoading7 = false;
            //     _this.$message.warning({
            //         message: '上传文件的图片大小不合符标准,宽需要为' + width + 'px，高需要为' + height + 'px。当前上传图片的宽高分别为：' + imgWidth + 'px和' + imgHeight + 'px',
            //         btn: false
            //     });
            //     return Promise.reject();
            //     this.thumbnailLoading7 = false;
            // });
            return isJPG && isLt2M ;
        },
      // 大赛简介图片上船
      handleSuccessImgUrl(res, file) {
          this.form.activityUrl = res.url;
          this.$refs.ruleForm.validateField('activityUrl')
      },
      beforeUploadImgUrl(file) {
          const isJPG = file.type.indexOf('image') !== -1;
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isJPG) {
              this.$message.warning('上传图片只能是图片格式!');
              this.thumbnailLoading4 = false
          }
          if (!isLt2M) {
              this.$message.warning('上传图片大小不能超过 2MB!');
              this.thumbnailLoading4 = false
          }
          return isJPG && isLt2M;
      },
      // 大赛简介视频上传
      handleSuccessVideoUrl(res, file) {
          this.form.activityVideoUrl = res.url;
          this.playerOptions.sources[0].src = res.url;
          this.$refs.ruleForm.validateField('activityVideoUrl')
          this.thumbnailLoading5 = false
      },
      beforeUploadVideoUrl(file) {
          this.thumbnailLoading5 = true
          const isJPG = file.type.indexOf('mp4') !== -1;
          const isLt2M = file.size / 1024 / 1024 < 50;
          if (!isJPG) {
              this.$message.warning('上传视频!');
              this.thumbnailLoading5 = false
          }
          if (!isLt2M) {
              this.$message.warning('上传视频大小不能超过 50MB!');
              this.thumbnailLoading5 = false
          }
          return isJPG && isLt2M;
      },
      // 奖项配图
      handleAvatarSuccessUrl(res, file) {
          this.formSuccess.awardUrl = res.url;
          this.thumbnailLoading3 = false;
          this.$refs.ruleForm.validateField('img')
      },
      beforeAvatarUploadUrl(file) {
          this.thumbnailLoading3 = true;
          const isJPG = file.type.indexOf('image') !== -1;
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isJPG) {
              this.$message.warning('上传图片只能是图片格式!');
              this.thumbnailLoading3 = false;
          }
          if (!isLt2M) {
              this.$message.warning('上传图片大小不能超过 2MB!');
              this.thumbnailLoading3 = false;
          }
          return isJPG && isLt2M;
      },
      resourceImg(name){
        getActivityTemplateStyleList({templateUuid:this.form.templateUuid}).then((res)=>{
          if(res.success){
            this.resource2 = res.data;
            let resourcePath = this.resource2.find(items=>{
                return items.uuid == this.form.styleUuid
            })
            this.resourImgs = resourcePath.path
            this.resourImgsList.push(resourcePath.path)
            this.form.styleName = name
          }
        });

      },
      chooseDate(){
          // 判断作品征集时间开始时间大于今天
          if(this.form.activityCollectTime.length>0){
              if(new Date(this.form.activityCollectTime[0]).getTime()<new Date().getTime()){
                  this.$message.error("征集开始时间要大于当前时间,请修改");
                  return false;
              }
          }
          // 判断时间
          if(this.form.activityCollectTime.length>0&&this.form.activityChooseTime.length>0){
              if(new Date(this.form.activityCollectTime[1]).getTime()>new Date(this.form.activityChooseTime[0]).getTime()){
                  this.$message.error("评选开始时间不允许小于征集结束时间,请修改");
                  return false;
              }
          }
          // 判断时间
          if(this.form.activityChooseTime.length>0&&this.form.activityShowStartDate!='') {
              if (new Date(this.form.activityChooseTime[1]).getTime() > new Date(this.form.activityShowStartDate).getTime()) {
                  this.$message.error("活动公示时间不允许小于评选结束时间,请修改");
                  return false;
              }
          }
          // 判断时间
          if(this.form.voteRatio>0) {
              if (this.form.activityVoteDate.length > 0 && this.form.activityCollectTime.length > 0) {
                  if (new Date(this.form.activityCollectTime[1]).getTime() > new Date(this.form.activityVoteDate[0]).getTime()) {
                      this.$message.error("投票开始时间不允许小于征集结束时间,请修改");
                      return false;
                  }
              }
          }
      },
      // 预览
      previewWeb(){
        this.$refs.ruleForm.validate((valid,obj) => {
          if (valid) {
            /*if(this.form.activityCollectTime.length == 2){
              this.form.activityCollectStartTime = this.timeDate(this.form.activityCollectTime[0]);
              this.form.activityCollectEndTime = this.timeDate(this.form.activityCollectTime[1]);
            }
            if(this.form.activityChooseTime.length == 2){
              this.form.activityChooseStartTime = this.timeDate(this.form.activityChooseTime[0]);
              this.form.activityChooseEndTime = this.timeDate(this.form.activityChooseTime[1]);
            }*/
            if(this.form.activityVoteDate.length == 2){
                this.form.activityVoteStartDate = this.timeDate(this.form.activityVoteDate[0]);
                this.form.activityVoteEndDate = this.timeDate(this.form.activityVoteDate[1]);
            }
            //this.form.activityShowStartDate = this.timeDate(this.form.activityShowStartDate);
            let dialogBox = document.body.clientHeight - 98 + 'px';
            this.form.editDate = new Date();
            this.form.dialogBox = dialogBox;
            console.log('this.templateClass', this.templateClass);
            console.log('this.skin', this.form);
            if(this.templateClass == '模板一'){
                this.$refs.activePreviewRefs.init(this.form,this.organizationList)
            }else if(this.templateClass == '模板二'){
                this.$refs.activePreviewRefs2.init(this.form,this.organizationList)
            }else if(this.templateClass == '模板三'){
                this.$refs.activePreviewRefs3.init(this.form,this.organizationList)
            }
          }else {
            for(let i in obj){
              let refsMess = i
              let dom = this.$refs[refsMess]
              dom.$el.scrollIntoView({
                //滚动到指定节点
                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
              })
            }
          }
        })
      },
      submit(index){
          this.form.organizationList = this.organizationList;
          if(index==0){
              this.form.status = "DRAFT";
          }else if(index==1){
              this.form.status = "PREPARE";
          }
          this.$refs.ruleForm.validate((valid,obj) => {
              if (valid) {
                /*if(this.form.activityCollectTime.length == 2){
                  this.form.activityCollectStartTime = this.timeDate(this.form.activityCollectTime[0]);
                  this.form.activityCollectEndTime = this.timeDate(this.form.activityCollectTime[1]);
                }
                if(this.form.activityChooseTime.length == 2){
                  this.form.activityChooseStartTime = this.timeDate(this.form.activityChooseTime[0]);
                  this.form.activityChooseEndTime = this.timeDate(this.form.activityChooseTime[1]);
                }*/
                if(this.form.activityVoteDate.length == 2){
                    this.form.activityVoteStartDate = this.timeDate(this.form.activityVoteDate[0]);
                    this.form.activityVoteEndDate = this.timeDate(this.form.activityVoteDate[1]);
                }
                  // 判断作品征集时间开始时间大于今天
                  /*if(this.form.activityCollectTime.length>0){
                      if(new Date(this.form.activityCollectTime[0]).getTime()<new Date().getTime()){
                          this.$message.error("征集开始时间要大于当前时间,请修改");
                          return false;
                      }
                  }*/
                  // 判断时间
                  /*if(this.form.activityCollectTime.length>0&&this.form.activityChooseTime.length>0){
                      if(new Date(this.form.activityCollectTime[1]).getTime()>new Date(this.form.activityChooseTime[0]).getTime()){
                          this.$message.error("评选开始时间不允许小于征集结束时间,请修改");
                          return false;
                      }
                  }
                  // 判断时间
                  if(this.form.activityChooseTime.length>0&&this.form.activityShowStartDate!='') {
                      if (new Date(this.form.activityChooseTime[1]).getTime() > new Date(this.form.activityShowStartDate).getTime()) {
                          this.$message.error("活动公示时间不允许小于评选结束时间,请修改");
                          return false;
                      }
                  }
                  // 判断时间
                  if(this.form.voteRatio>0) {
                      if (this.form.activityVoteDate.length > 0 && this.form.activityCollectTime.length > 0) {
                          if (new Date(this.form.activityCollectTime[1]).getTime() > new Date(this.form.activityVoteDate[0]).getTime()) {
                              this.$message.error("投票开始时间不允许小于征集结束时间,请修改");
                              return false;
                          }
                      }
                  }*/
                //this.form.activityShowStartDate = this.timeDate(this.form.activityShowStartDate);
                if(this.type=='add') {
                    saveActivityInfo(this.form).then((res) => {
                        if (res.success) {
                            if (index == 0) {
                                this.$message.success("保存成功");
                            } else if (index == 1) {
                                this.$message.success("发布成功");
                            }
                            this.dialogVisible = false;
                            this.$emit('submit');
                        }
                    });
                }else if(this.type=='edit'){
                    editActivityInfo(this.form).then((res) => {
                        if (res.success) {
                            if (index == 0) {
                                this.$message.success("编辑成功");
                            } else if (index == 1) {
                                this.$message.success("发布成功");
                            }
                            this.dialogVisible = false;
                            this.$emit('submit');
                        }
                    });
                }
              }else {
                for(let i in obj){
                  let refsMess = i
                  let dom = this.$refs[refsMess];
                  dom.$el.scrollIntoView({
                    //滚动到指定节点
                    block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                    behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                  })

                }

              }
          });
      },
      // 初始话重置表单
      reset(){
          this.thumbnailLogoList = [];
          this.form = {
              templateUuid: '',
              styleUuid: '',
              activityName: '',
              sponsorName: '',
              undertakerName: '',
              jointlyName: '',
              activityCollectTime: [],
              activityCollectStartTime:"",
              activityCollectEndTime:"",
              activityChooseTime: [],
              activityChooseStartTime:"",
              activityChooseEndTime:"",
              activityShowStartDate: "",
              logoList:[],
              activityLogo: '',
              bannerUrl: '',
              voteRatio: '',
              judgesAppraisalRatio: '',
              voteTime: '',
              typeList: [],
              awardList: [],
              activityUrl: '',
              activityVideoUrl: '',
              content: '',
              entryDemand: '',
              entryRule: '',
              entryGuide: '',
              fileContent:"",
              fileList:[],
              status:"",
              voteNum:0,
              wayList:[],
              nodeList:[],
              appBannerUrl: '',
          };
          this.thumbnailLoading = false
      },
      compare(array, key) {
          return array.sort(function (a, b) {
              const x = a[key];
              const y = b[key];
              return ((x < y) ? -1 : (x > y) ? 1 : 0)
          });
      },
      // 编辑器内容更新
      editHomepageInput(val){
          this.$refs.ruleForm.validateField('entryDemand')
      },
      // 编辑器内容更新
      editHomepageInput2(val){
          this.$refs.ruleForm.validateField('entryRule')
      },
      editEntryGuideInput(val){
          this.$refs.ruleForm.validateField('entryGuide')
      },
      countVote(){
          let numReg = /^[0-9]*$/;
          let numRe = new RegExp(numReg);
          if (!numRe.test(this.form.voteRatio)) {
              this.$message.error("请输入数字");
              this.form.voteRatio = 0;
          }else if (this.form.voteRatio > 100) {
              this.$message.error("请输入小于或者等于100的参数");
              this.form.voteRatio = 100;
              this.form.judgesAppraisalRatio = 0;
          }else{
              this.form.judgesAppraisalRatio = 100 - Number(this.form.voteRatio);
          }
      },
      timeDate(value){
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? "0" + MM : MM;
          let d = date.getDate();
          d = d < 10 ? "0" + d : d;
          let h = date.getHours();
          h = h < 10 ? "0" + h : h;
          let m = date.getMinutes();
          m = m < 10 ? "0" + m : m;
          let s = date.getSeconds();
          s = s < 10 ? "0" + s : s;
          return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      },
        // 点击添加赛道
        addTrackData(){
            this.$refs.trackDetailRefs.init();
        },
        getTrackDetail(item){
            if(typeof item.updateIndex==='number'){
                // 直接赋值过去
                this.form.wayList[item.updateIndex] = item;
            }else{
                this.form.wayList.push({
                    name:item.name,
                    voteRatio:item.voteRatio,
                    judgesAppraisalRatio:item.judgesAppraisalRatio,
                    typeList:item.typeList,
                    awardList:item.awardList,
                });
            }
        },
        updateTrackInfo(item,index){
            item.updateIndex = index;
            this.$refs.trackDetailRefs.init(item);
        },
        delTrackNext(index){
            this.form.wayList.splice(index,1);
        },
        // 点击增加时间
        addActivityDateData(){
           // 判断长度是否超过5个
            if(this.form.nodeList.length>=5){
                this.$message.warning("该活动时间节点增加已到上限!");
                return;
            }
            this.$refs.activityDateRefs.init(null,this.form.nodeList);
        },
        delActivityDateNext(index){
            this.form.nodeList.splice(index,1);
        },
        updateActivityDateInfo(item,index){
            item.updateIndex = index;
            this.$refs.activityDateRefs.init(item,this.form.nodeList);
        },
        showStatusInfo(result){
           if(result === "PREPARE"){
               return "准备中";
           }else if(result === "COLLECT"){
               return "征集中";
           }else if(result === "EVALUATE"){
               return "评选中";
           }else if(result === "FINISHED"){
               return "已结束";
           }
        },
        getActivityDateInfo(item){
            if(typeof item.updateIndex==='number'){
                // 直接赋值过去
                this.form.nodeList[item.updateIndex] = item;
            }else{
                this.form.nodeList.push({
                    name:item.name,
                    startDate:item.startDate,
                    endDate: item.endDate,
                    status: item.status,
                    sort:item.sort,
                    dateType:item.dateType,
                });
            }
            this.form.nodeList = this.compare(this.form.nodeList,'sort');
        },
        getClearIamgs(type){
            if(type == "img") this.form.activityUrl = ''
            if(type == "video") this.form.activityVideoUrl = ''

        }
    }
}
</script>

<style scoped lang="less">
.imgsMess {
  margin: 0;
  margin-left: 10px;
  color: #a1a1a1;
}
// /deep/.el-dialog__body {
//   padding: 20px 0;
// }
.organiContent{
    /deep/.el-textarea__inner{
        min-height: 70px !important;
    }
}
.dialogContent {
    // padding: 0 5%;

    /deep/.el-upload-list--picture-card .el-upload-list__item{
        width: 590px;
        height: 300px;
    }
    /deep/.el-upload--picture-card{
        width: 590px;
        height: 300px;
        line-height: 300px;
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
        width: 590px;
        height: 300px;
    }
    /deep/.el-form-item {
      margin-right: 90px;
    }
    .titleTop {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 26px;
      padding-left: 48px;
      border-top: 1px solid #efefef;
      padding-top: 30px;
      &:nth-of-type(1){
        border-top: none;
        padding-top: 0;
      }
    }
    // 活动模板
    .templateBox {
      display: flex;
      .templateBox_check {
        .templateBox_checkName {
          margin-bottom: 23px;
          min-width: 400px;
        }
        .templateBox_check2 {
          /deep/.el-form-item__content {
            background: #c1e0ff42;
            border-radius: 4px;
            padding: 4px 24px;
          }
          .templateBox_check2Uuid {
            display: flex;
            align-items: center;
            p {
              margin: 0;
              margin-right: 26px;
            }
          }
        }
      }
      .templateBox_imgs {
        display: flex;
        align-items: flex-end;
        position: relative;
        height: 103px;
        width: 60px;
        img {
          height: 103px;
          width: 60px;
        }
        p {
          color: #409eff;
          cursor: pointer;
          margin: 0;
          position: absolute;
          bottom: 0;
          right: -70px;
          text-decoration:underline;
        }
      }

    }
    // 活动封面和banner
    .activeBanner {
      display: flex;

    }
    .upload-demo {
      margin-top: 10px;
    }
    .thumbnailClass{
        width: 222px;
        height: 125px;
        .avatar{
            width: 222px;
            height: 125px;
            border: 1px dashed #ddd;
            border-radius: 4px;
            line-height: 125px;
            font-size: 50px;
        }
    }
    .thumbnailClass2{
        width: 222px;
        height: 125px;
        // margin-left: 16px;
        margin-bottom: 5px;
    }
    .thumbnailClass20{
      height: 122px;
        .avatar2{
            width: 222px;
            height: 125px;
            border: 1px dashed #ddd;
            border-radius: 4px;
            line-height: 125px;
            font-size: 50px;
            p {
              margin: 0;
              font-size: 16px;
            }
        }
    }
    .thumbnailClassLogo {
      /deep/.el-upload-list__item {
        width: 222px;
        height: 125px;
      }
      img {
        width: 222px !important;
        height: 125px !important;
      }
      /deep/.el-upload--picture-card {
        width: 222px;
        height: 125px;
        line-height: 125px;
      }
    }
    .endPeriodClass{
        /deep/.el-form-item__content{
            margin-left: 0 !important;
        }
    }
    .submitButtonClass{
        /deep/.el-form-item__content{
            margin-left: 0 !important;
            text-align: center;
            button{
                padding: 0;
                width: 120px;
                height: 35px;
                line-height: 35px;
                border-radius: 6px;
            }
        }
    }
    .modelHeightRangeClass{
        display: flex;
        margin-bottom: 25px;
        /deep/.el-form-item__content{
            margin-left: 0 !important;
        }
    }
}
.successImgsUrl {
    cursor: pointer;
    color: #409EFF;
    width:100%;
    //height:150px;
}
.video-js .vjs-big-play-button {
  width: 72px;
  height: 72px;
  border-radius: 100%;
  z-index: 100;
  background-color: #ffffff;
  border: solid 1px #979797;
}
.dialogFormVisibleDialog {
  /deeep/.el-dialog__body {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
}
.awaedUrlImgs {
  /deep/.el-image {
    width: 125px;
    height: 154px;
  }
}
.imageBox {
    position: relative;
    &:hover {
        .hoverImages {
            display: block;
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: #ffffff6b;
        }
    }
    .hoverImage {
        display: none;
    }
    .imageBoxClear {
        position: absolute;
        right: 7px;
        top: 8px;
        color: #000;
        cursor: pointer;
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/activityManagementDialog.vue